export const blockIconsEditorInsertLink = (
	<span className='material-symbols-outlined'>insert_link</span>
);
